export default "__VITE_ASSET__UClsr2ks__"